<template>
    <div class="main-container">
        <div class="tier-header">
            <img
                v-if="getUserlevel.userlevel === 'gold'"
                src="@/assets/profile/header_gold.svg"
                alt=""
            />
            <img
                v-else-if="getUserlevel.userlevel === 'silver'"
                src="@/assets/profile/header_silver.svg"
                alt=""
            />
            <img v-else src="@/assets/profile/header_bronze.svg" alt="" />
        </div>
        <div class="profile-container">
            <div class="profile-main">
                <div v-if="line_image" class="profile-image">
                    <img :src="line_image" alt="line-image" />
                </div>
                <div v-else class="profile-image-noborder">
                    <img src="@/assets/icon/default_profile.svg" />
                </div>
                <div class="detail-container">
                    <div class="greeting-container">
                        <p class="profile-name">
                            {{ profile.FirstName }}
                            {{ profile.LastName }}
                        </p>
                    </div>
                    <div class="wrapper_heaser_two">
                        <p>
                            คุณมี
                            <span class="value-coin"
                                >{{
                                    profile.updated_points
                                        ? numberWithCommas(
                                              profile.updated_points.points
                                          )
                                        : ""
                                }}
                            </span>
                            คะแนน
                            <img
                                class="ic"
                                src="../../../assets/icon/icon_points.svg"
                                alt=""
                            />
                        </p>
                    </div>
                </div>
            </div>
            <div
                id="profile-qrcode-btn"
                class="wrapper-qr old"
                @click="showQRCode()"
            >
                <span>
                    รับคะแนน
                    <img
                        class="ic_qr"
                        src="../../../assets/icon/qr_header.svg"
                        alt=""
                    />
                </span>
            </div>
            <ModalMaster :controller="modalController"></ModalMaster>
        </div>
    </div>
</template>

<script>
//service
import BzbsApi from "@/core/Account/service/BzbsProfile.js";
import CacheHelper from "@/helper/CacheHelper.js";
// mixins
import ModalMixin from "@/mixin/ModalMixin";
//vuex
import { mapGetters } from "vuex";

export default {
    name: "profile",
    mixins: [ModalMixin],
    data: function () {
        return {
            cacheHelper: new CacheHelper(),
            profile: {},
            line_image: null,
        };
    },
    beforeDestroy() {
        clearInterval(this.runClockSerialInterval);
    },
    created: function () {
        this.line_image = this.cacheHelper.getCache("BzbsUser").line.pictureUrl;
        this.getProfile();
        this.initialRedeemModal();
    },
    computed: mapGetters(["getUserlevel"]),
    methods: {
        getProfile() {
            BzbsApi.getProfile(
                this.cacheHelper.getCache("BzbsUser").token
            ).then((response) => {
                this.profile = response.data;
                this.QrModal.setProfile(this.profile);
            });
        },
        numberWithCommas(x) {
            if (x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (x == 0) {
                return 0;
            } else {
                return "-";
            }
        },
        showQRCode() {
            this.QrModal.show();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/module/List/style/profile.scss";
</style>
